module.exports = __webpack_public_path__ + "static/img/cont45_01.44d7ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont45_01.jpg
// module id = sQzm
// module chunks = 0